// passwordPolicy.js — FAZA 15
//
// Lexon politikën globale të fjalëkalimit (security_policy, vendoset nga admini
// te Admin Center → Staff & Security) dhe e zbaton në formularët e regjistrimit
// të app-it. Vlen për app + Admin Center (i njëjti burim).
//
// Përdorim:
//   const pol = await getPasswordPolicy();
//   if (!pol.allow_signups) { ...; return; }
//   const chk = validatePassword(pw, pol);
//   if (!chk.ok) { setError(passwordErrorText(chk.errors)); return; }

import { supabase } from "./supabaseClient";
// ⚠ 4 shtator 2026 — ky skedar s'është komponent, pra s'ka `useTranslation`.
// Instanca e i18n-it importohet drejtpërdrejt; është e njëjta që përdor
// `serverText.js`. Pa këtë, mesazhi i fjalëkalimit dilte shqip në çdo gjuhë.
import i18n from "./i18n";

const DEFAULTS = {
  password_min_length: 8,
  require_uppercase: false,
  require_lowercase: false,
  require_number: false,
  require_symbol: false,
  allow_signups: true,
};

let _cache = null;
export async function getPasswordPolicy() {
  if (_cache) return _cache;
  try {
    const { data } = await supabase.rpc("rpc_get_security_policy");
    const row = Array.isArray(data) ? data[0] : data;
    _cache = row ? { ...DEFAULTS, ...row } : DEFAULTS;
  } catch (_e) {
    _cache = DEFAULTS;
  }
  return _cache;
}

export function validatePassword(pw, policy) {
  const p = policy || DEFAULTS;
  const s = pw || "";
  const errors = [];
  if (s.length < (p.password_min_length || 8)) errors.push({ k: "minlen", n: p.password_min_length || 8 });
  if (p.require_uppercase && !/[A-Z]/.test(s)) errors.push({ k: "upper" });
  if (p.require_lowercase && !/[a-z]/.test(s)) errors.push({ k: "lower" });
  if (p.require_number && !/[0-9]/.test(s)) errors.push({ k: "number" });
  if (p.require_symbol && !/[^A-Za-z0-9]/.test(s)) errors.push({ k: "symbol" });
  return { ok: errors.length === 0, errors };
}

// Mesazhi ndërtohet nga copa të përkthyeshme. Çelësat janë vetë teksti shqip,
// si kudo tjetër te aplikacioni.
export function passwordErrorText(errors) {
  const map = {
    minlen: (e) => i18n.t("at least {{n}} characters", { n: e.n }),
    upper: () => i18n.t("an uppercase letter"),
    lower: () => i18n.t("a lowercase letter"),
    number: () => i18n.t("a number"),
    symbol: () => i18n.t("a symbol"),
  };
  return i18n.t("The password must have: ") + errors.map((e) => (map[e.k] ? map[e.k](e) : "")).filter(Boolean).join(", ") + ".";
}

// ⚠ Ishte konstante — pra e ngrirë në gjuhën e nisjes. Tani funksion, që
// përkthimi të lexohet në çastin e përdorimit, jo në atë të ngarkimit.
export function signupsDisabledMsg() {
  return i18n.t("New sign-ups are switched off for now.");
}
